import { createButton } from './common/ui'

export class UiMenu extends PIXI.Container
{
    constructor(config = configUiMenu_mobile_vertical) {

        super();

        let self = this;

        const packFolder = config.packFolder;

        this.sndBtnClick = sounds.get(config.sndBtnClick);
        const snd = this.sndBtnClick;

        this.buttonHelp         = createButton(this, config.buttonHelpPosition.x, config.buttonHelpPosition.y, packFolder + "s_info", snd, true);
        this.buttonSettings     = createButton(this, config.buttonSettingsPosition.x, config.buttonSettingsPosition.y, packFolder + "s_settings", snd, true);

        this.layerButtonAuto = new PIXI.Container();
        this.addChild(this.layerButtonAuto);
        this.buttonAutoOn       = createButton(this.layerButtonAuto, config.buttonAutoOnPosition.x, config.buttonAutoOnPosition.y, packFolder + "autoplay_on", snd);
        this.buttonAutoOff      = createButton(this.layerButtonAuto, config.buttonAutoOffPosition.x, config.buttonAutoOffPosition.y, packFolder + "autoplay_off", snd);

        this.buttonExit         = createButton(this, config.buttonExitPosition.x, config.buttonExitPosition.y, packFolder + "s_exit", snd);
        this.buttonSoundOn      = createButton(this, config.buttonSoundOnPosition.x, config.buttonSoundOnPosition.y, packFolder + "s_sound_on", snd);
        this.buttonSoundOff     = createButton(this, config.buttonSoundOffPosition.x, config.buttonSoundOffPosition.y, packFolder + "s_sound_off", snd);

        let setSwitchBehaviorForTwoButtons = function(buttonOn, buttonOff, isButtonOnActive) {
            // переключатель состоит из двух кнопок - переключаем их видимость при отжатии
            let onUp = function() {
                let button = buttonOn.visible ? buttonOff : buttonOn;
                buttonOn.visible = buttonOff.visible = false;
                button.visible = true;
            };
            buttonOn.on('pointerup', onUp);
            buttonOff.on('pointerup', onUp);
            buttonOn.visible    = isButtonOnActive;
            buttonOff.visible   = !isButtonOnActive;
        };

        setSwitchBehaviorForTwoButtons(this.buttonAutoOn, this.buttonAutoOff, false);
        setSwitchBehaviorForTwoButtons(this.buttonSoundOn, this.buttonSoundOff, true);

        // вкл - когда кнопка Off отжимается
        this.buttonSoundOff.callback = function() {sounds.muteAll(false);};
        this.buttonSoundOn.callback = function() {sounds.muteAll(true);};
    };

    terminate () {
        this.removeChildren();
        this.destroy();

        this.sndBtnClick.stop();
        this.sndBtnClick = null;

        this.buttonHelp = null;
        this.buttonSettings = null;
        this.buttonAutoOn = null;
        this.buttonAutoOff = null;
        this.layerButtonAuto = null;
        this.buttonExit = null;
        this.buttonSoundOn = null;
        this.buttonSoundOff = null;
    }

    addLobbyButtonToNewParrent (newParent) {
        this.removeChild(this.buttonExit);
        newParent.addChild(this.buttonExit);
    }

    setAlphaAllButtons (alpha) {
        this.buttonHelp.alpha = alpha;
        this.buttonSettings.alpha = alpha;
        this.buttonExit.alpha = alpha;
        this.buttonAutoOn.alpha = alpha;
        this.buttonAutoOff.alpha = alpha;
        this.buttonSoundOn.alpha = alpha;
        this.buttonSoundOff.alpha = alpha;
    }

    lockSettingsButton () {
        this.buttonSettings.enabled = false;
    }

    unlockSettingsButton () {
        this.buttonSettings.enabled = true;
    }

    setOnButtonSettingsEvent (func) {
        this.buttonSettings.callback = function() {func();};
    }

    setOnButtonHelpEvent (func) {
        this.buttonHelp.callback = function() {func();};
    }

    setOnButtonExitEvent (func) {
        this.buttonExit.callback = function() {func();};
    }

    // вкл - когда кнопка soundOff отжимается
    setOnButtonSoundOnEvent (func) {
        this.buttonSoundOff.callback = function() {sounds.muteAll(false); func();};
    }

    // выкл - когда кнопка soundOn отжимается
    setOnButtonSoundOffEvent (func) {
        this.buttonSoundOn.callback = function() {sounds.muteAll(true); func();};
    }

    setSoundButtonState (isOn) {
        this.buttonSoundOn.visible = !isOn;
        this.buttonSoundOff.visible = isOn;
        sounds.muteAll(isOn);
    }

    // вкл - когда кнопка buttonAutoOff отжимается
    setOnButtonAutoPlayOnEvent (func) {
        this.buttonAutoOff.callback = function() {func();};
    }

    // выкл - когда кнопка buttonAutoOn отжимается
    setOnButtonAutoPlayOffEvent (func) {
        this.buttonAutoOn.callback = function() {func();};
    }

    sendAutoplayOffEvent () {
        this.buttonAutoOn.callback();
    }

    setAutoPlayButtonVisible (isVisible) {
        this.layerButtonAuto.visible = isVisible;
    }

    setAutoPlayButtonState (isOn) {
        this.buttonAutoOn.visible = isOn;
        this.buttonAutoOff.visible = !isOn;
    }

    setAutoPlayButtonEnable (isEnable) {
        this.buttonAutoOn.alpha = this.buttonAutoOff.alpha = isEnable ? 1 : 0.5;
        this.buttonAutoOn.enabled = this.buttonAutoOff.enabled = isEnable;
    }
}

const resourcesUiMenu_mobile_vertical = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            "res/common/minigames/sounds/btn_click",
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/common/minigames/menu/mobile_vertical/common.json",
            {name: "res/common/minigames/menu/mobile_vertical/menu.json", rus: true},
        ]
};

export const configUiMenu_mobile_vertical = {
    resources: resourcesUiMenu_mobile_vertical,
    packFolder: "minigames_menu_mobile_vertical/",
    sndBtnClick: "res/common/minigames/sounds/btn_click",
    buttonHelpPosition:     {x: 461, y: 171},
    buttonSettingsPosition: {x: 461, y: 94},
    buttonAutoOnPosition:   {x: 11, y: 150},
    buttonAutoOffPosition:  {x: 11, y: 150},
    buttonExitPosition:     {x: 11, y: 17},
    buttonSoundOnPosition:  {x: 461, y: 18},
    buttonSoundOffPosition: {x: 461, y: 18},
};



// WEBPACK FOOTER //
// ./src/library/minigame_client/ui/menu.es6